import {
  IWorkflowDurationOptions,
  WorkflowDurationType,
  WorkflowDurationUnit,
} from '~/client/graph'

import {
  MILLISECONDS_IN_DAY,
  MILLISECONDS_IN_HOUR,
  MILLISECONDS_IN_MINUTE,
  MILLISECONDS_IN_MONTH,
  MILLISECONDS_IN_WEEK,
} from '../stores/ui/ProjectDate.store'

export const durationToMilliseconds = (
  durationOptions: IWorkflowDurationOptions,
): number => {
  if (durationOptions.durationType !== WorkflowDurationType.Time) {
    return
  }

  switch (durationOptions.durationUnit) {
    case WorkflowDurationUnit.Minutes:
      return durationOptions.duration * MILLISECONDS_IN_MINUTE
    case WorkflowDurationUnit.Hours:
      return durationOptions.duration * MILLISECONDS_IN_HOUR
    case WorkflowDurationUnit.Days:
      return durationOptions.duration * MILLISECONDS_IN_DAY
    case WorkflowDurationUnit.Weeks:
      return durationOptions.duration * MILLISECONDS_IN_WEEK
    case WorkflowDurationUnit.Months:
      return durationOptions.duration * MILLISECONDS_IN_MONTH
  }
}
